import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const getRandomColor = () => {
  let n = (Math.random() * 0xfffff * 1000000).toString(16);
  return "#" + n.slice(0, 6);
};

const processData = (data, key = "service_name") => {
  const result = {};

  data.forEach((item) => {
    const keyName = item[key];
    if (result[keyName]) {
      result[keyName].value += 1;
    } else {
      result[keyName] = {
        name: keyName,
        value: 1,
        color: getRandomColor(),
      };
    }
  });

  return Object.keys(result).map((name) => result[name]);
};

const BarChartComponent = ({
  data,
  groupByKey = "service_name",
  width = 500,
  height = 300,
  dataKey = "value",
  showTooltip = true,
}) => {
  const processedData = processData(data, groupByKey);

  // Calculate the total value of all bars
  const totalValue = processedData.reduce((sum, item) => sum + item.value, 0);

  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart
        data={processedData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        {showTooltip && <Tooltip formatter={(value) => `${value}`} />}
        <Bar
          dataKey={dataKey}
          legendType="circle"
          label={{
            position: "top",
            formatter: (value) =>
              `(${((value / totalValue) * 100).toFixed(2)}%)`,
          }}
        >
          {processedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry["color"]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
